import { useNavigate } from 'react-router-dom';
import { Box, Stack, Typography } from '@mui/material';
import { MyButton } from '@/components';

const sectionStyle = { width: '100%', minWidth: 0 };

const stackStyle = {
  width: '100%',
  maxWidth: '480px',
  '@media (min-width: 2200px)': {
    maxWidth: '560px',
  },
  margin: '0 auto',
  textAlign: {
    xs: 'center',
    sm: 'left',
  },
  alignItems: {
    xs: 'center',
    sm: 'flex-start',
  },
  justifyContent: 'center',
  gap: '14px',
};
const typographyH4Style = {
  textTransform: {
    xs: 'uppercase',
    sm: 'none',
  },
  fontSize: {
    xs: '20px',
    sm: '32px',
  },
  fontWeight: '700',
};
const boxStyle = {
  display: 'flex',
  width: {
    xs: '100%',
    sm: 'auto',
  },
  gap: '20px',
  marginTop: '12px',
  flexDirection: {
    xs: 'column',
    sm: 'row',
  },
};

export const Welcome = () => {
  const navigate = useNavigate();

  return (
    <section style={sectionStyle}>
      <Stack sx={stackStyle}>
        <Typography variant='h4' sx={typographyH4Style}>
          We&rsquo;re thrilled to&nbsp;have you on board at&nbsp;
          <span style={{ color: '#1650FF' }}>Online Property!</span>
        </Typography>

        <Typography variant='body1' sx={{ fontSize: 16 }}>
          Please bear with&nbsp;us for any possible errors and bug 😄 We&rsquo;re in&nbsp;beta
          testing, and your input is&nbsp;invaluable!
        </Typography>
        <Box sx={boxStyle}>
          <MyButton
            data={{
              customWidth: '177px',
              buttonName: 'Sign up',
              variant: 'contained',
              buttonType: 'submit',
              dataQa: 'sign_up_btn',
            }}
            onClick={() => navigate('/signUp')}
          />
          <MyButton
            data={{
              customWidth: '177px',
              buttonName: 'Log in',
              variant: 'outlined',
              styleType: 'cancel',
              dataQa: 'login_btn',
            }}
            onClick={() => navigate('/logIn')}
          />
        </Box>
      </Stack>
    </section>
  );
};
